<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path
      d="M25 14.9999L15 24.9999M15 14.9999L25 24.9999M36.6666 19.9999C36.6666 29.2047 29.2047 36.6666 20 36.6666C10.7952 36.6666 3.33331 29.2047 3.33331 19.9999C3.33331 10.7952 10.7952 3.33325 20 3.33325C29.2047 3.33325 36.6666 10.7952 36.6666 19.9999Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
